export default __webpack_public_path__ + "static/media/herobg2.6d224ecb.png";